exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-feedback[data-v-67fdd1d6] {\n  color: red;\n}", ""]);

// exports
